import {
  IsNotEmpty,
  IsEmail,
  IsOptional,
  ValidateNested,
  IsArray,
  ValidateIf,
  IsDate,
  IsBoolean,
} from "class-validator";
import { Type } from "class-transformer";

import { AddressDto } from "../common";
import { JuniorNumberDto } from "./junior-number.dto";

export class UserCreateDto {
  @IsNotEmpty()
  @IsEmail(undefined, { message: "Invalid email" })
  email: string;

  @IsNotEmpty({ message: "First Name cannot be empty" })
  first_name: string;

  @IsNotEmpty({ message: "Last Name cannot be empty" })
  last_name: string;

  @IsOptional()
  display_name?: string;

  @IsOptional()
  phone?: string;

  @IsOptional()
  @ValidateNested()
  @Type(() => AddressDto)
  address?: AddressDto;

  @IsOptional()
  @IsBoolean()
  is_junior?: boolean;

  @IsOptional()
  parent_name?: string;

  @ValidateIf((o) => o.is_junior === true)
  @IsNotEmpty({ message: "Date of birth is required for junior accounts" })
  @IsDate({ message: "Invalid date of birth" })
  @Type(() => Date)
  junior_dob?: Date;

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => JuniorNumberDto)
  junior_numbers?: JuniorNumberDto[];

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => JuniorNumberDto)
  membership_numbers?: JuniorNumberDto[];

  @IsOptional()
  @IsBoolean()
  is_trusted_secretary?: boolean;
}
